import React from 'react'
import Link from 'gatsby-link'

const Header = () => (
  <div
    style={{
      background: '#000040',
      padding: '25px 0',
      position: 'absolute',
      width: '100%',
      zIndex: 500
    }}
  >
    <div className="container">
      <div className="row">
        <div className="col-xs-12 col-md-6 text-center text-md-left">
          <h1 style={{ fontSize: '1.5rem', margin: 0 }}>
            <Link
              to="/"
              style={{
                color: 'white',
                textDecoration: 'none',
              }}
            >
              <img src={require('./logo.png')} style={{
                maxWidth: '45px',
                margin: '-20px 15px -15px 0'
              }} />
              Ridley Owen &amp; Sons
            </Link>
          </h1>
        </div>
        <div className="d-none d-md-block col-md-6 text-right">
          <span style={{ display: 'block', color: 'white', marginTop: '-10px'}}>Build, Refurbish, Maintain</span>
          <h3 style={{ color: 'white', fontSize: '1.5rem', margin: '0 0 -10px 0' }}>
            07484 259007
          </h3>
        </div>
      </div>
    </div>
  </div>
)

export default Header



// WEBPACK FOOTER //
// ./src/components/Header/index.js